module.exports = __webpack_public_path__ + "img/tips-gps-icon.9941d3dd.svg";